import templateUrl from './phone-template.html';

export const phoneTemplateComponent = {
	bindings:{
		details: '<',
		onAdd: '&',
		onDelete: '&',
		hidePhonePurpose: '@'
	},

	templateUrl,
	
	controller: class PhoneTemplateComponent {
		constructor($timeout) {
			'ngInject';

			this.$timeout = $timeout;
		}

		onFocus(label, index) {
			this.$timeout(() => {
				index !== 0 ? document.getElementById(`${label}_${index}`).focus() : true;
			});
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/components/phone-template/phone-template.component.js